import { BaseProvider } from "./base.provider";
export class LeapProvider extends BaseProvider {
    init() { }
}
